import React from "react";
import { CommonEmptyContentBlock } from "../CommonEmptyContentBlock";

export const EmptyActionsBlock = ({ text, isProvider, redirectTo }) => {
	return (
		<CommonEmptyContentBlock
			iconClass="icon-balance"
			title={text.NO_ACTIONS_HEADER}
			description={isProvider ? text.NO_PROVIDER_ACTIONS : text.NO_OPERATOR_ACTIONS}
			linkTo={redirectTo}
			actionButtonText={text.menuRates}
		/>
	);
};
